module.exports = __webpack_public_path__ + "static/media/experience.f7327e2d.png";